import {OptionMap} from "../../helpers/optionMap";

export const departmentSources = ['declarant', 'sigma', 'created'] as const;
export type DepartmentSource = typeof departmentSources[number];

export const departmentSourcesMap = new OptionMap<DepartmentSource>({
  'declarant': 'Declarant',
  'sigma': 'Sigma',
  'created': 'Created'
});

export function isDepartmentSource(source: unknown): source is DepartmentSource {
  if(typeof source !== 'string') {
    return false;
  }
  return departmentSources.includes(source as DepartmentSource);
}